import React, { useContext, useEffect, useState } from 'react'
import { DatePicker, Layout, Menu, Select } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { adminMenu } from '../../lists/adminMenu'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import { useLocation, useNavigate } from 'react-router-dom'
import MyTable from '../../modules/MyTable/MyTable'
import { ColumnsType } from 'antd/es/table'
import { ContextType } from '../../type/type'
import { getRequest, getRequestAuth, getRequestNew } from '../../request/request'
import moment from 'moment'
import { parseUrl } from '../../function/parseUrl'
import Search from 'antd/lib/input/Search'
import { AppContext } from '../../App'
import { useTranslation } from 'react-i18next'
import validatorServerErrors from '../../modules/ValidatorServerErrors/ValidatorServerErrors'
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'
import { JWT } from '../../reduser/Reduser'
const { RangePicker } = DatePicker
import style from './style/style.module.scss'

const MyTrophies = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [data, setData] = useState<any[] | null>(null)
  const [reload, setReload] = useState<boolean>(false)
  const [trophyTypeList, setTrophyTypeList] = useState<any | null>([{ id: 'all', name: t('h127') }])
  const [isTrophyTypeList, setIsTrophyTypeList] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [valueType, setValueType] = useState<string>('')
  const [valueExpertStatus, setValueExpertStatus] = useState('all')
  const [valueTrophyStatus, setValueTrophyStatus] = useState('all')
  const [reloadPagination, setReloadPagination] = useState(false)
  const [dataSearch, setDataSearch] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = useLocation()
  const [sortOrder, setSortOrder] = useState<any | null>(null)
  const [pagination, setPagination] = useState(() => {
    const urlParams = new URLSearchParams(location.search)
    return {
      current: parseInt(urlParams.get('page') || '1', 10),
      pageSize: 50,
      total: 50,
    }
  })
  const type = pathname.split('/cabinet/')[1]
  const dateFormat = 'DD.MM.YYYY'
  const { role } = state?.me?.user || {}
  const options = [
    {
      value: 'all',
      label: t('h209'),
    },
    {
      value: 'active',
      label: t('h207'),
    },
    {
      value: 'unactive',
      label: t('h208'),
    },
  ]
  const optionsTrophyStatus = [
    {
      value: 'all',
      label: t('h210'),
    },
    {
      value: 'AWT',
      label: t('h132'),
    },
    {
      value: 'CND',
      label: t('h148'),
    },
    {
      value: 'APD',
      label: t('h149'),
    },
    {
      value: 'RJC',
      label: t('h150'),
    },
  ]

  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)
  const [valueRangeDate, setValueRangeDate] = useState<any>(null)
  const serverFormat = 'YYYY-MM-DDT21:00:00Z'

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  useEffect(() => {
    setValueType(t('h127'))
    getRequest('/trophy_book/trophy_type')
      .then((res: any) => {
        setTrophyTypeList([{ id: 'all', name: t('h127') }, ...res.data.results])
        setIsTrophyTypeList(false)
      })
      .catch((err) => {
        validatorServerErrors(err.data)
        setIsTrophyTypeList(false)
      })
  }, [state.lang])

  useEffect(() => {
    setLoading(true)
    let meId: number | string

    const query = location.search.split('?')[1]
    const type = parseUrl('?', 'trophy_type_id')
    const expertStatus = parseUrl('?', 'expert_status')
    const status = parseUrl('?', 'status')
    const search = parseUrl('?', 'search')
    const ordering = parseUrl('?', 'ordering')

    if (type) setValueType(type)
    if (status) setValueTrophyStatus(status)
    if (expertStatus === 'true') {
      setValueExpertStatus('active')
    } else if (expertStatus === 'false') {
      setValueExpertStatus('unactive')
    } else {
      setValueExpertStatus('all')
    }

    if (search) setDataSearch(search)
    if (ordering) defaultOrdering(ordering)

    if (state?.me?.id) {
      meId = state.me.id
    } else {
      getRequestAuth('/profile/about_me/')
        .then((res: any) => {
          const { id } = res.data
          meId = id
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          dispatch({
            type: JWT,
            payload: null,
          })
        })
    }

    getRequestNew(`/trophy_book/expert_statistics?${query || ''}`)
      .then((res: any) => {
        setLoading(false)
        setPagination({
          ...pagination,
          total: res.data.count,
        })
        setData(res.data.results)
      })
      .catch((err) => {
        validatorServerErrors(err.data)
        setLoading(false)
      })
  }, [reload, reloadPagination, state.reload])

  const defaultOrdering = (ordering: string) => {
    const parts = ordering.split('-')

    if (parts.length > 1) {
      setSortOrder({ field: parts[1], order: 'descend' })
    } else {
      setSortOrder({ field: parts[0], order: 'ascend' })
    }
  }

  const columns: ColumnsType = [
    {
      title: t('h201'),
      dataIndex: 'expert_email',
      key: 'expert_email',
      width: 120,
    },
    {
      title: t('h202'),
      dataIndex: 'expert_active',
      key: 'expert_active',
      align: 'center',
      width: 100,
      render: (_, value: any) => <span>{value ? 'Активный' : 'Неактивный'}</span>,
    },
    {
      title: t('h203'),
      dataIndex: 'trophy_type',
      key: 'trophy_type',
      align: 'center',
      width: 70,
      sorter: true,
      sortOrder: sortOrder?.field === 'trophy_type' ? sortOrder.order : undefined,
      render: (_, value: any) => {
        return <span>{value?.trophy_type.name}</span>
      },
    },
    {
      title: t('h204'),
      dataIndex: 'date_creation',
      key: 'date_creation',
      align: 'center',
      width: 75,
      sorter: true,
      sortOrder: sortOrder?.field === 'date_creation' ? sortOrder.order : undefined,
      render: (_, { date_creation }: any) => moment(date_creation).format(dateFormat),
    },
    {
      title: t('h205'),
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 100,
      sorter: true,
      sortOrder: sortOrder?.field === 'status' ? sortOrder.order : undefined,
      render: (_, { status }: any) => {
        switch (status) {
          case 'AWT':
            return <span>{t('h132')}</span>
          case 'CND':
            return <span>{t('h148')}</span>
          case 'APD':
            return <span>{t('h149')}</span>
          case 'RJC':
            return <span>{t('h150')}</span>
        }
      },
    },
    {
      title: t('h206'),
      dataIndex: 'reason_rejection',
      key: 'reason_rejection',
      align: 'center',
      width: 200,
      render: (_, { reasons_rejection }: any) => {
        switch (reasons_rejection) {
          case 'ICR':
            return <span>{t('h173')}</span>
          case 'RPH':
            return <span>{t('h174')}</span>
          case 'BQA':
            return <span>{t('h175')}</span>
          case 'RQS':
            return <span>{t('h176')}</span>
          case 'PVD':
            return <span>{t('h177')}</span>
          default:
            return <span>--</span>
        }
      },
    },
  ]

  const updateQueryParams = (newParams: any) => {
    const queryParams = new URLSearchParams(location.search)
    // Статус эксперта
    if (newParams.expert_status) {
      switch (newParams.expert_status) {
        case 'all':
          queryParams.delete('expert_status')
          break
        case 'active':
          queryParams.set('expert_status', 'true')
          break
        case 'unactive':
          queryParams.set('expert_status', 'false')
          break
      }
    }
    // Поиск
    if (!newParams.search) {
      queryParams.delete('search')
    } else if (newParams.search !== undefined) {
      queryParams.set('search', newParams.search)
    }
    // Статус трофея
    if (newParams.status === 'all') {
      queryParams.delete('status')
    } else if (newParams.status !== undefined) {
      queryParams.set('status', newParams.status)
    }
    // Дата начала периода
    if (newParams.date_from !== undefined) {
      queryParams.set('date_from', newParams.date_from)
    }
    // Дата конца периода
    if (newParams.date_to !== undefined) {
      queryParams.set('date_to', newParams.date_to)
    }
    // Тип трофея
    if (newParams.trophy_type_id === 'all') {
      queryParams.delete('trophy_type_id')
    } else if (newParams.trophy_type_id !== undefined) {
      queryParams.set('trophy_type_id', newParams.trophy_type_id)
    }
    queryParams.set('page', '1')

    navigate(`?${queryParams.toString()}`)
    setReload((prev: boolean) => !prev)
  }

  const handleChangeExpertStatus = (value: string) => {
    setPagination({ ...pagination, current: 1 })
    setValueExpertStatus(value)
    updateQueryParams({ expert_status: value })
  }

  const handleChangeType = (value: string) => {
    setPagination({ ...pagination, current: 1 })
    setValueType(value)
    updateQueryParams({ trophy_type_id: value })
  }

  const handleChangeExpertTrophy = (value: string) => {
    setPagination({ ...pagination, current: 1 })
    setValueTrophyStatus(value)
    updateQueryParams({ status: value })
  }

  const handleRangePicker = (value: any) => {
    setPagination({ ...pagination, current: 1 })
    const queryParams = new URLSearchParams(location.search)

    if (!value) {
      setValueRangeDate(null)
      queryParams.delete('date_from')
      queryParams.delete('date_to')
      navigate(`?${queryParams.toString()}`)
      setReload((prev: boolean) => !prev)
      return
    }

    const date_from = moment(value[0]._d).format(serverFormat)
    const date_to = moment(value[1]._d).format(serverFormat)

    setValueRangeDate({
      date_from: moment(date_from).format(dateFormat),
      date_to: moment(date_to).format(dateFormat),
    })
    updateQueryParams({ date_from, date_to })
  }

  const onSearch = (value: string) => {
    setLoading(true)
    setDataSearch(value)
    updateQueryParams({ search: value })
    setSortOrder(null)
  }

  return (
    <Layout className="br-12">
      <Content>
        <WrapperData>
          <Search
            placeholder={t('h200')}
            allowClear
            enterButton={t('h45')}
            size="large"
            value={dataSearch}
            onChange={({ target }) => {
              setDataSearch(target.value)
            }}
            onSearch={onSearch}
            className="search-trophies"
          />
          <br />
          <br />

          <div className="wrapper_filter">
            {/* Селект статус эксперта */}
            <Select
              className="my_select"
              value={valueExpertStatus}
              style={{ width: 200 }}
              listHeight={170}
              onChange={handleChangeExpertStatus}
              options={options}
            />

            {/* Селект тип трофея */}
            <Select
              showSearch
              className="my_select"
              value={valueType}
              placeholder={t('h104')}
              loading={isTrophyTypeList}
              optionFilterProp="children"
              listHeight={150}
              style={{ width: 200, margin: '0 8px 0 0' }}
              onChange={handleChangeType}
              filterOption={(input, option: any) =>
                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {trophyTypeList?.map(({ id, name }: { id: number; name: string }) => (
                <React.Fragment key={id + name}>
                  <Select.Option value={String(id)}>{name}</Select.Option>
                </React.Fragment>
              ))}
            </Select>

            {/* Селект статусы трофеев */}
            <Select
              className="my_select"
              value={valueTrophyStatus}
              style={{ width: 200 }}
              listHeight={170}
              onChange={handleChangeExpertTrophy}
              options={optionsTrophyStatus}
            />

            {/* Выбор временной интервал */}
            <RangePicker
              onChange={handleRangePicker}
              format={dateFormat}
              className={style.my_picker}
              value={[
                valueRangeDate?.date_from && moment(valueRangeDate?.date_from, dateFormat),
                valueRangeDate?.date_to && moment(valueRangeDate?.date_to, dateFormat),
              ]}
            />
          </div>
          <MyTable
            columns={columns}
            data={data}
            loading={loading}
            height={900}
            pagination={pagination}
            setPagination={setPagination}
            setReloadPagination={setReloadPagination}
            setSortOrder={setSortOrder}
            sortOrder={sortOrder}
            scroll={{ x: '100%' }}
          />
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default MyTrophies
